var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-selected__item"},[_c('div',{staticClass:"c-selected__item-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"c-selected__item-value"},[_vm._v(_vm._s(_vm.selectedName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }